import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { TextField, TextFieldProps } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { isEmpty } from "../../../helpers/StringHelpers"
import DateOfBirtValidator from "../../../services/validation/personal-and-contact-details-form/DateOfBirthValidator"

interface FormFieldProps {
    defaultValue: Date | null
    handleChange: (value: Date | null) => void
    errorText?: string
    isDisabled?: boolean
}

function DateOfBirthInputField(props: FormFieldProps) {
    const { t } = useTranslation(`signup`)
    const { handleChange, errorText, defaultValue, isDisabled } = props
    const [helperText, setHelperText] = useState<string | undefined>(errorText)

    const validateField = (date: Date | null) => {
        const validationText = (new DateOfBirtValidator()).validate(date)
        setHelperText(validationText)
        return validationText
    }

    const handleOnChange = (date: Date | null) => {
        validateField(date)
        handleChange(date)
    }

    const handleOnBlur = (event: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
        if (isEmpty(event.target.value)) {
            validateField(null)
        }
    }

    useEffect(() => {
        setHelperText(errorText)
    }, [errorText])

    const textField = (params: TextFieldProps) => {
        return (
            <TextField
                {...params}
                id="dob-input"
                type="date"
                fullWidth
                margin="normal"
                error={helperText !== undefined && helperText !== ``}
                onBlur={handleOnBlur}
                helperText={helperText ? t(helperText) : ``}
                disabled={isDisabled}
            />
        )
    }

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DesktopDatePicker
                label={t(`dob`)}
                value={defaultValue}
                inputFormat="DD/MM/yyyy"
                onChange={handleOnChange}
                onAccept={handleOnChange}
                renderInput={textField}
                disabled={isDisabled}
            />
        </LocalizationProvider>
    )
}

export default DateOfBirthInputField